// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"ab82233d","688":"bc9a058e","984":"d794ae5f"}[chunkId] + ".chunk.css";
};